import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { Component, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizReadonlyAlert from "@/components/quiz/QuizReadonlyAlert.vue";
import QuizCheckableTextQuestion from "@/components/quiz/QuizCheckableTextQuestion.vue";
import QuizSimpleTextQuestion from "@/components/quiz/QuizSimpleTextQuestion.vue";
import QuizBlanksQuestion from "@/components/quiz/QuizBlanksQuestion.vue";
import QuizUtils from "@/util/quizUtils";
import QuizPairsMatchingQuestion from "@/components/quiz/QuizPairsMatchingQuestion.vue";
import QuizSortingQuestion from "@/components/quiz/QuizSortingQuestion.vue";
let QuizAnswersValidationAlert = class QuizAnswersValidationAlert extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "question", void 0);
    _defineProperty(this, "answersValidationState", void 0);
  }
  isMultiCheckQuestion(question) {
    return QuizUtils.isMultiCheckQuestion(question.type);
  }
  isBlanksQuestion(question) {
    return QuizUtils.isBlanksQuestion(question.type);
  }
  isPairsMatchingQuestion(question) {
    return QuizUtils.isPairsMatchingQuestion(question.type);
  }
  isSortingQuestion(question) {
    return QuizUtils.isSortingQuestion(question.type);
  }
  shouldDisplayValidationMsgInPlural(question) {
    if (this.isMultiCheckQuestion(question)) {
      return true;
    } else if (this.isPairsMatchingQuestion(question) || this.isSortingQuestion(question)) {
      return true;
    } else if (this.isBlanksQuestion(question)) {
      return question.blanks.length > 1;
    }
    return false;
  }
};
__decorate([Prop({
  required: true,
  default: null
})], QuizAnswersValidationAlert.prototype, "question", void 0);
__decorate([Prop({
  required: true,
  default: null
})], QuizAnswersValidationAlert.prototype, "answersValidationState", void 0);
QuizAnswersValidationAlert = __decorate([Component({
  components: {
    QuizSortingQuestion,
    QuizPairsMatchingQuestion,
    QuizBlanksQuestion,
    QuizSimpleTextQuestion,
    QuizCheckableTextQuestion,
    QuizReadonlyAlert,
    WInput,
    StandardButton
  }
})], QuizAnswersValidationAlert);
export default QuizAnswersValidationAlert;